import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { updateReviewCheckList } from '../../../../redux/WellGuardian';
import { useCountryState } from '../../../../redux/WellGuardian/selectors';
import wellGuardianApiClient from 'services/networking/wellGuardianApiClient';
import { ChecklistQuestions, CountryData } from 'types/wellGuardian';

const EQUIPMENT_PROCUREMENT_UK_ID = 23;

const NUPRC_NG_ID = 2;
const WONS_CHECK_ID = 2;
const WONS_CHECK_NAME = 'WONS consent required?';
const HAZOP_CHECK_ID = 311;

export const useChecklistData = () => {
  const dispatch = useDispatch();
  const [checklistQs, setChecklistQs] = useState<ChecklistQuestions | null>(null);
  const [checklistQsLoading, setChecklistQsLoading] = useState<boolean>(false);
  const countryState = useCountryState();

  const fetchChecklistData = useCallback(async () => {
    setChecklistQsLoading(true);
    const response = await wellGuardianApiClient.getChecklistQs(countryState);
    if (response?.generic) {
      let generic = response.generic;
      if (countryState !== CountryData.unitedKingdom) {
        generic = generic.filter(list => list.check_id !== EQUIPMENT_PROCUREMENT_UK_ID);

        if (countryState === CountryData.angola) {
          generic = response.generic.filter(list => list.check_id !== NUPRC_NG_ID);
        }
      }

      const hazopIndex = generic.findIndex(list => list.check_id === HAZOP_CHECK_ID);
      const wonsIndex = generic.findIndex(
        list => list.check_id === WONS_CHECK_ID && list.check_name.startsWith(WONS_CHECK_NAME),
      );
      if (hazopIndex !== -1 && wonsIndex !== -1 && hazopIndex !== wonsIndex + 1) {
        generic = [...generic];
        const [hazop] = generic.splice(hazopIndex, 1);
        const updatedWonsIndex = generic.findIndex(
          list => list.check_id === WONS_CHECK_ID && list.check_name.startsWith(WONS_CHECK_NAME),
        );
        generic.splice(updatedWonsIndex + 1, 0, hazop);
      }

      setChecklistQs({ ...response, generic });
    } else {
      setChecklistQs(response);
    }
    dispatch(updateReviewCheckList(response));
    setChecklistQsLoading(false);
  }, [countryState, dispatch]);

  useEffect(() => {
    fetchChecklistData();
  }, [fetchChecklistData]);

  return {
    checklistQsLoading,
    checklistQs,
  };
};
